import React, { useState } from 'react';
import { createRoot } from 'react-dom/client';
import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/Button';

interface ConfirmOptions {
  title?: string;
  message: string;
}

export const confirm = (messageOrOptions: string | ConfirmOptions): Promise<boolean> => {
  if (typeof document === 'undefined') {
    return Promise.resolve(false);
  }

  // 後方互換性のため、文字列が渡された場合はmessageとして扱う
  const options: ConfirmOptions =
    typeof messageOrOptions === 'string' ? { message: messageOrOptions } : messageOrOptions;

  const { title = '確認', message } = options;

  return new Promise((resolve) => {
    const container = document.createElement('div');
    document.body.appendChild(container);

    const root = createRoot(container);

    const GlobalConfirmDialog: React.FC = () => {
      const [isOpen, setIsOpen] = useState(true);

      const cleanup = () => {
        root.unmount();
        if (container.parentNode) {
          container.parentNode.removeChild(container);
        }
      };

      const handleConfirm = () => {
        resolve(true);
        setIsOpen(false);
        cleanup();
      };

      const handleCancel = () => {
        resolve(false);
        setIsOpen(false);
        cleanup();
      };

      return (
        <Dialog
          open={isOpen}
          onOpenChange={(nextOpen) => {
            if (!nextOpen) handleCancel();
          }}
        >
          <DialogContent className="w-full max-w-screen-sm rounded shadow-xl!">
            <div className="flex items-center justify-between border-b border-solid border-gray-200 px-6 py-4">
              <DialogTitle className="text-base! font-bold! text-gray-900">{title}</DialogTitle>
            </div>

            <div className="p-6">
              <p className="text-sm leading-relaxed text-gray-900">{message}</p>
            </div>

            <div className="flex justify-end gap-4 border-t border-solid border-gray-200 px-6 py-4">
              <Button color="secondary" size="md" onClick={handleCancel}>
                キャンセル
              </Button>
              <Button color="danger" size="md" onClick={handleConfirm}>
                確定する
              </Button>
            </div>
          </DialogContent>
        </Dialog>
      );
    };

    root.render(<GlobalConfirmDialog />);
  });
};
